<mat-toolbar>
  <div class="d-flex h-100 w-100 align-items-center justify-content-between">
    <div class="h-100 d-flex gap-2 align-items-center">
      @if ((responsiveService.isMobileScreen$ | async) === true) {
        <img
          class="h-75 cursor--pointer"
          src="/logo-stamp.png"
          alt="Het Netwerk Levend Erfgoed"
          routerLink="/"
        >
        <a
          href="https://netwerklevenderfgoed.nl/"
          target="_blank"
          rel="noopener noreferrer"
          mat-mini-fab
          aria-label="Het Netwerk Levend Erfgoed website"
          class="flat-mini-fab"
        >
          <mat-icon fontSet="material-symbols-outlined" class="text-heading">home</mat-icon>
        </a>
      } @else {
        <img
          class="h-75 cursor--pointer"
          src="/nle-logo-black.png"
          alt="Het Netwerk Levend Erfgoed"
          routerLink="/"
        >
        <a
          href="https://netwerklevenderfgoed.nl/"
          target="_blank"
          rel="noopener noreferrer"
          mat-mini-fab
          aria-label="Het Netwerk Levend Erfgoed website"
          class="flat-mini-fab"
        >
          <mat-icon fontSet="material-symbols-outlined" class="text-heading">home</mat-icon>
        </a>
      }
    </div>

    <div class="app-title flex justify-center">
      <div class="text-center" style="line-height: 0.7;">
        <h2 class="m-0 p-0 font-weight--700" style="font-size: 1.125rem; color: #000000;">Het Netwerk Levend
          Erfgoed</h2>
        <span style="font-size: 14px;font-weight: 400;">Overzicht Levend Erfgoed Initiatieven in Nederland</span>
      </div>
    </div>


    <div class="d-flex gap-2">
      @if ((responsiveService.isMobileScreen$ | async) === true) {
        <button
          (click)="openFiltersSheet()"
          mat-mini-fab
          aria-label="Filteren"
          class="flat-mini-fab"
        >
          <mat-icon fontSet="material-symbols-outlined" class="text-primary">filter_alt</mat-icon>
        </button>
      }


      @if ((responsiveService.isMobileScreen$ | async) === false) {
        <button routerLink="/organization-map" matButton="tonal" class="danger-button">
          <mat-icon fontSet="material-symbols-outlined">location_on</mat-icon>
          Kaart
        </button>
      } @else {
        <button
          mat-mini-fab
          aria-label="Kaart"
          routerLink="/organization-map"
          routerLinkActive="fab-active"
        >
          <mat-icon fontSet="material-symbols-outlined" class="text-primary">location_on</mat-icon>
        </button>
      }

      @if ((responsiveService.isMobileScreen$ | async) === false) {
        <button routerLink="/organization-list" matButton="tonal" class="danger-button">
          <mat-icon>list</mat-icon>
          Lijst
        </button>
      } @else {
        <button
          mat-mini-fab
          aria-label="Lijst"
          routerLink="/organization-list"
          routerLinkActive="fab-active"
        >
          <mat-icon fontSet="material-symbols-outlined" class="text-primary">list</mat-icon>
        </button>
      }

      @if ((responsiveService.isMobileScreen$ | async) === false) {
        <button routerLink="/claim-ownership" matButton="outlined" class="inscribe-button text-interactive">
          <mat-icon class="text-interactive" fontSet="material-symbols-outlined">add_circle</mat-icon>
          Meld je aan
        </button>
      } @else {
        <button
          mat-mini-fab
          aria-label="Meld je aan"
          routerLink="/claim-ownership"
        >
          <mat-icon fontSet="material-symbols-outlined" class="text-primary">add_circle</mat-icon>
        </button>
      }
    </div>
  </div>
</mat-toolbar>

@if (showFilterHeader$ | async) {
  <mat-toolbar class="secondary-toolbar">
    <div
      class="w-100 d-flex gap-2 my-2"
      [class]="(responsiveService.isLargeDesktopScreen$ | async) === true ? 'flex-row': 'flex-column'"
    >
      <div
        class="w-100 d-flex flex-row gap-2"
        [ngClass]="{'flex-column': ['tablet','mobile'].includes((responsiveService.currentBreakpoint$ | async) ?? '')}"
      >

        <div class="flex-1">
          <!-- Search -->
          <mat-form-field appearance="outline" class="w-100 no-subscript search-form-field">
            <mat-icon matPrefix>search</mat-icon>
            <input [formControl]="searchQueryInput" matInput
                   placeholder="Zoek organisaties" aria-label="Zoek organisaties" value="">
          </mat-form-field>
        </div>


        <div
          class="d-flex flex-row gap-2"
          [ngClass]="{'flex-column': responsiveService.isMobileScreen$ | async}"
        >
          <!-- Goal -->
          <mat-form-field appearance="outline" class="no-subscript">
            <mat-select [formControl]="goalSelect" multiple
                        panelClass="goal-select-panel"
                        placeholder="Alle doelen" aria-label="Alle doelen">
              @for (goal of goalList; track goal.id) {
                <mat-option [value]="goal"
                            [style.--goal-color]="goalColor(goal).color"
                            [style.--goal-background]="goalColor(goal).background">{{ goal.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Goal more information -->
          <mat-icon
            fontSet="material-symbols-outlined"
            [matMenuTriggerFor]="goalsPopover"
            class="cursor--pointer text-white--hover align-self-center mr-1"
          >
            information
          </mat-icon>

          <!-- Goal more information panel -->
          <mat-menu #goalsPopover="matMenu">
            <ng-template matMenuContent>
              <div class="px-3 py-1">
                <h3 class="m-0 p-0">Doel</h3>
                <p
                  class="my-2 font-weight--400"
                >
                  Waarom zijn de makers en deelnemers betrokken?
                </p>
                <a
                  href="https://netwerklevenderfgoed.nl/classificatie-erfgoedinitiatieven"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="d-flex align-items-center cta-link"
                >
                  <mat-icon fontSet="material-symbols-outlined" class="icon-as-text">open_in_new</mat-icon>&nbsp;Meer
                  informatie
                </a>
              </div>
            </ng-template>
          </mat-menu>

          <!-- Reach -->
          <mat-form-field appearance="outline" class="no-subscript">
            <mat-select [formControl]="reachSelect" multiple
                        placeholder="Alle reikwijdten" aria-label="Alle reikwijdten">
              @for (reach of reachList; track reach.id) {
                <mat-option [value]="reach">{{ reach.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Reach more information -->
          <mat-icon
            fontSet="material-symbols-outlined"
            [matMenuTriggerFor]="reachPopover"
            class="cursor--pointer text-white--hover align-self-center mr-1"
          >
            information
          </mat-icon>

          <!-- Reach more information panel -->
          <mat-menu #reachPopover="matMenu">
            <ng-template matMenuContent>
              <div class="px-3 py-1">
                <h3 class="m-0 p-0">Reikwijdte</h3>
                <p
                  class="my-2 font-weight--400"
                >
                  Bereikt het initiatief mensen op lokaal- of provinciaal niveau of landelijk?
                </p>
                <a
                  href="https://netwerklevenderfgoed.nl/classificatie-erfgoedinitiatieven"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="d-flex align-items-center cta-link"
                >
                  <mat-icon fontSet="material-symbols-outlined" class="icon-as-text">open_in_new</mat-icon>&nbsp;Meer
                  informatie
                </a>
              </div>
            </ng-template>
          </mat-menu>

          <!-- Province -->
          <mat-form-field appearance="outline" class="no-subscript">
            <mat-select [formControl]="provinceSelect" multiple
                        placeholder="Alle provincies" aria-label="Alle provincies">
              @for (province of provinceList; track province.id) {
                <mat-option [value]="province">{{ province.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

        </div>
      </div>

      <div class="d-flex gap-2">

        <!-- Heritage type -->
        <mat-form-field appearance="outline" class="no-subscript">
          <mat-select [formControl]="heritageTypeSelect" multiple
                        placeholder="Alle erfgoedtypes" aria-label="Alle erfgoedtypes">
            @for (heritageType of heritageTypeList; track heritageType.id) {
              <mat-option [value]="heritageType">{{ heritageType.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- Heritage type more information -->
        <mat-icon
          fontSet="material-symbols-outlined"
          [matMenuTriggerFor]="heritageTypePopover"
          class="cursor--pointer text-white--hover align-self-center mr-1"
        >
          information
        </mat-icon>

        <!-- Heritage type more information panel -->
        <mat-menu #heritageTypePopover="matMenu">
          <ng-template matMenuContent>
            <div class="px-3 py-1">
              <h3 class="m-0 p-0">Type erfgoed</h3>
              <p
                class="my-2 font-weight--400"
              >
                Welke termen omschrijven de activiteiten van deze groep het best?
              </p>
              <a
                href="https://netwerklevenderfgoed.nl/classificatie-erfgoedinitiatieven"
                target="_blank"
                rel="noopener noreferrer"
                class="d-flex align-items-center cta-link"
              >
                <mat-icon fontSet="material-symbols-outlined" class="icon-as-text">open_in_new</mat-icon>&nbsp;Meer
                informatie
              </a>
            </div>
          </ng-template>
        </mat-menu>

        <!-- Impact type -->
        <mat-form-field appearance="outline" class="no-subscript">
          <mat-select [formControl]="impactTypeSelect" multiple
                        placeholder="Alle impacttypes" aria-label="Alle impacttypes">
            @for (impactType of impactTypeList; track impactType.id) {
              <mat-option [value]="impactType">{{ impactType.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- Impact type more information -->
        <mat-icon
          fontSet="material-symbols-outlined"
          [matMenuTriggerFor]="impactTypePopover"
          class="cursor--pointer text-white--hover align-self-center mr-1"
        >
          information
        </mat-icon>

        <!-- Impact type more information panel -->
        <mat-menu #impactTypePopover="matMenu">
          <ng-template matMenuContent>
            <div class="px-3 py-1">
              <h3 class="m-0 p-0">Impacttype</h3>
              <p
                class="my-2 font-weight--400"
              >
                Welke impact of waarde heeft deze groep op/voor de leefomgeving, cultuur en/of natuur?
              </p>
              <a
                href="https://netwerklevenderfgoed.nl/classificatie-erfgoedinitiatieven"
                target="_blank"
                rel="noopener noreferrer"
                class="d-flex align-items-center cta-link"
              >
                <mat-icon fontSet="material-symbols-outlined" class="icon-as-text">open_in_new</mat-icon>&nbsp;Meer
                informatie
              </a>
            </div>
          </ng-template>
        </mat-menu>

        <!-- Reset -->
        <div class="d-flex align-items-center">
          <button mat-stroked-button (click)="clearFilters()">
            <span class="text-white">Wis filters</span>
          </button>
        </div>
      </div>
    </div>
    <!-- Result count -->
    <div class="d-flex flex-row-reverse align-items-center secondary-toolbar__count">
      {{ (appStateStore.organizationList$ | async)?.length ?? 0 }} organisaties gevonden
    </div>
  </mat-toolbar>
}
<div
  class="app-progress-bar"
  [ngClass]="{
  'app-progress-bar__mobile': (responsiveService.isMobileScreen$ | async) === true
  }"
>
  @if (appStateStore.loading$ | async) {
    <mat-progress-bar
      mode="indeterminate"
    ></mat-progress-bar>
  }
</div>

<div
  class="main-content"
  [ngClass]="{
  'main-content__tablet': (responsiveService.isTabletScreen$ | async) === true,
  'main-content__no-sub-header': (showFilterHeader$ | async) === false,
  'main-content__no-sub-header__mobile': (responsiveService.isMobileScreen$ | async) === true
  }"
>
  <router-outlet></router-outlet>
</div>
